import { Calendar } from 'lucide-react';
import { MatchList } from '../matches/MatchList';

export default function NextMatch() {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center gap-2 mb-4">
        <Calendar className="w-5 h-5 text-[#2173B9]" />
        <h3 className="text-lg font-semibold">Next Matches</h3>
      </div>
      <MatchList type="next" limit={3} showLeague={false} />
    </div>
  );
}
